<template>
<div>
	<div id="mobile-navi">
		<div>{{user.token.email}}</div>
		<div>
			<a v-bind:href="user.manage">Manage Account <i class="icon icon_edit"></i></a>
		</div>
		<div>
			<a v-on:click="logout" href="#">Log out <i class="icon icon_logout"></i></a>
		</div>
	</div>
	<header>
		<nav>
			<div id="logo"><img src="~@/assets/img/logo.png" /></div>
			<div id="account">
				<div id="burger" v-on:click="toggleNav"><i class="icon icon_burger"></i></div>
				<div id="account-inner" class="">
					<span>{{user.token.email}}</span>
					<span class="icons">
						<a v-bind:href="user.manage"><i class="icon icon_edit"></i></a>
						<a v-on:click="logout" href="#"><i class="icon icon_logout"></i></a>
					</span>
				</div>
			</div>
		</nav>
	</header>
</div>
</template>

<script>
export default {
	name: 'HeaderTemplate',
	props: {
		user: Object,
		logout: Function
	},
	methods: {
		toggleNav: () => {
			document.getElementById('mobile-navi').classList.toggle('show');
			document.getElementById('burger').querySelector('i.icon').classList.toggle('icon_burger');
			document.getElementById('burger').querySelector('i.icon').classList.toggle('icon_close');
		}
	},
}
</script>
